import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Modal from '@material-ui/core/Modal';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { Box, LinearProgress, Pagination, TextField } from '@mui/material';
import Switch from '@mui/material/Switch';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useStore } from 'react-redux';
import { useHistory } from 'react-router-dom';
import _, { debounce } from 'lodash';
import querystring from 'querystring';
import API from '../../../create/api';

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700,
  },
  search: {
    display: 'flex',
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

export default function SpanningTable() {
  const store = useStore();
  const classes = useStyles();

  const [get_page_no, set_page_no] = useState(1);
  const [get_total_company_count, set_total_company_count] = useState(0);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);

  const initialLimit = localStorage.getItem('companyLimit')
    ? JSON.parse(localStorage.getItem('companyLimit') ?? '')
    : 500;
  const initialSortType = localStorage.getItem('companySort')
    ? JSON.parse(localStorage.getItem('companySort') ?? '')
    : 'id:ASC';
  const [limit, setLimit] = React.useState(initialLimit);
  const [sortBy, setSortBy] = useState(initialSortType);
  const [search, setSearch] = useState('');

  const apiName = 'companies';
  async function fetchAPI() {
    setLoading(true);
    const getCompany = {
      _start: (get_page_no - 1) * limit,
      _limit: limit,
      _sort: sortBy,
      _q: search,
    };

    const param = querystring.encode(_.pickBy(getCompany, _.identity));
    const [companies, count]: any[] = await Promise.all([
      API.getAll(`${process.env.REACT_APP_API_SERVER}/companies?${param}`),
      API.count(`${process.env.REACT_APP_API_SERVER}/companies/count?${param}`),
    ]);
    setRows(companies);
    set_total_company_count(count);
    setLoading(false);
  }
  useEffect(() => {
    fetchAPI();
  }, [get_page_no, limit, sortBy, search]);

  const history = useHistory();

  const [deleteID, setDeleteID] = useState(undefined);
  const [open, setOpen] = React.useState(false);

  const handleOpen = (id: any) => {
    setDeleteID(id);
    setOpen(true);
  };
  const handleClose = () => {
    setDeleteID(undefined);
    setOpen(false);
  };

  // rest api
  async function deleteAPN() {
    if (deleteID) {
      await API.destroy(`${process.env.REACT_APP_API_SERVER}/${apiName}`, deleteID)
        .then((res) => {
          fetchAPI();
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          handleClose();
        });
    }
  }
  const handleSearchField = debounce((searchValue: string) => {
    setSearch(searchValue);
  }, 3000);

  return (
    <TableContainer component={Paper}>
      {loading && <LinearProgress />}
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div className={classes.paper}>
          <h1 id="spring-modal-title">Delete</h1>
          <p id="spring-modal-description">
            Do you want to delete ID {deleteID}
            <br />
            <Button color="secondary" onClick={deleteAPN}>
              Yes
            </Button>
            <Button color="primary" onClick={handleClose}>
              No
            </Button>
          </p>
        </div>
      </Modal>
      <Table className={classes.table} aria-label="a spanning dense table" padding="checkbox">
        <TableHead>
          <TableRow>
            <TableCell colSpan={2} align="left">
              <Box className={classes.search}>
                <span>Search</span>
                <TextField
                  style={{ marginLeft: '10px' }}
                  fullWidth
                  variant="standard"
                  onChange={(e) => {
                    handleSearchField(e?.target.value);
                  }}
                />
              </Box>
            </TableCell>
            <TableCell colSpan={12} align="right">
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'end',
                  padding: '5px',
                }}
              >
                <Pagination
                  color="primary"
                  count={Math.ceil(get_total_company_count / limit)}
                  variant="outlined"
                  shape="rounded"
                  page={get_page_no}
                  onChange={(e, page) => {
                    set_page_no(page);
                  }}
                />
                <Box sx={{ px: 2 }}>
                  <label htmlFor="limit">Set limit:</label>
                  <select
                    onChange={(e: any) => {
                      setLimit(e.target.value);
                      localStorage.setItem('companyLimit', JSON.stringify(e.target.value));
                    }}
                    style={{ cursor: 'pointer', padding: '5px' }}
                    defaultValue={limit}
                  >
                    <option value={10}>10</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={250}>250</option>
                    <option value={500}>500</option>
                  </select>
                </Box>
                <Box>
                  <label htmlFor="sort">Sort by:</label>
                  <select
                    value={sortBy}
                    onChange={(e: any) => {
                      setSortBy(e.target.value);
                      localStorage.setItem('companySort', JSON.stringify(e.target.value));
                    }}
                    style={{ cursor: 'pointer', padding: '5px' }}
                  >
                    <option value={'id:ASC'}>Old to New</option>
                    <option value={'id:DESC'}>New to Old</option>
                    <option value={'name:ASC'}>A to Z</option>
                    <option value={'updated_at:DESC'}>Last Update</option>
                  </select>
                </Box>
              </div>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell align="left">Name</TableCell>
            <TableCell align="left" style={{ paddingLeft: '13px' }}>
              Status
            </TableCell>
            <TableCell align="center">Edit</TableCell>
            <TableCell align="center">Delete</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row: any) => (
            <TableRow key={row.id}>
              <TableCell>{row.id}</TableCell>
              <TableCell align="left">{row.name}</TableCell>
              <TableCell align="left">
                <Switch
                  {...{ inputProps: { 'aria-label': 'Switch demo' } }}
                  checked={row?.user?.confirmed}
                  onChange={async (e) => {
                    await axios
                      .put(
                        `${process.env.REACT_APP_API_SERVER}/companies/verify/${row.id}`,
                        { confirmed: e.target.checked, user: row?.user?.id },
                        {
                          headers: {
                            Authorization: `Bearer ${store.getState().auth.jwt}`,
                          },
                        },
                      )
                      .then((response) => {
                        setTimeout(() => {
                          fetchAPI();
                        }, 1000);
                      });
                  }}
                />
              </TableCell>
              <TableCell align="center">
                <IconButton
                  color="primary"
                  onClick={() => {
                    history.push(`/dashboard/${apiName}/edit/${row.id}`);
                  }}
                >
                  <EditIcon />
                </IconButton>
              </TableCell>
              <TableCell align="center">
                <IconButton
                  color="secondary"
                  onClick={() => {
                    handleOpen(row.id);
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
